import { extendTheme } from '@chakra-ui/react'

const theme = extendTheme({
  config: {
    initialColorMode: 'dark',
    useSystemColorMode: false,
  },
  styles: {
    global: {
      body: {
        bg: '#150d04',
        color: 'white'
      }
    }
  },
  fonts: {
    // Rozha One: single-weight (400) Latin + Devanagari display serif
    heading: "'Rozha One', Georgia, serif",
    body: "Inter, system-ui, Avenir, Helvetica, Arial, sans-serif",
  },
  // Glass tiers — border alpha scale: 0.10 tile rest / 0.18 card rest / 0.35 hover
  layerStyles: {
    glassTile: {
      bg: 'rgba(255,150,50,0.04)',
      border: '1px solid rgba(255,150,50,0.10)',
      backdropFilter: 'blur(12px)',
      borderRadius: 'lg',
    },
    glassCard: {
      bg: 'rgba(40,24,8,0.92)',
      border: '1px solid rgba(255,150,50,0.18)',
      backdropFilter: 'blur(12px)',
      borderRadius: 'xl',
    },
  },
  colors: {
    brand: {
      50: '#fff8e1',
      100: '#ffecb3',
      200: '#ffe082',
      300: '#ffd54f',
      400: '#ffca28',
      500: '#ff9800',
      600: '#fb8c00',
      700: '#f57c00',
      800: '#ef6c00',
      900: '#e65100',
    },
    terracotta: {
      50:  '#fdf0ec',
      100: '#fad4c4',
      200: '#f5ad8e',
      300: '#ef8660',
      400: '#e56535',
      500: '#c44d1c',
      600: '#9e3a12',
      700: '#7a290b',
      800: '#581b06',
      900: '#3a0f02',
    }
  },
  components: {
    Heading: {
      baseStyle: {
        color: 'white',
        // Rozha One ships only weight 400 — synthesized bold distorts the glyphs
        fontWeight: 'normal',
        letterSpacing: 'normal',
      },
      variants: {
        gradient: {
          bgGradient: 'linear(to-r, brand.400, terracotta.400)',
          bgClip: 'text'
        }
      }
    },
    Text: {
      baseStyle: {
        color: 'white'
      },
      variants: {
        secondary: { color: 'whiteAlpha.800' },
        muted:     { color: 'whiteAlpha.700' },
        accent:    { color: 'brand.300', fontWeight: 'bold' }
      }
    },
    Link: {
      baseStyle: {
        _hover: { textDecoration: 'none' }
      },
      variants: {
        nav: {
          color: 'whiteAlpha.900',
          fontWeight: 'medium',
          _hover: { color: 'brand.300' },
          _active: { color: 'brand.300', fontWeight: 'bold' }
        }
      }
    },
    Button: {
      variants: {
        solid: {
          bg: 'brand.500',
          color: 'white',
          _hover: {
            bg: 'brand.600',
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 25px rgba(255, 152, 0, 0.4)',
          }
        },
        outline: {
          borderColor: 'brand.500',
          color: 'brand.300',
          _hover: {
            bg: 'whiteAlpha.100',
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 25px rgba(180, 80, 20, 0.3)',
          }
        },
        ghost: {
          color: 'whiteAlpha.900',
          _hover: {
            bg: 'whiteAlpha.100',
            color: 'brand.300'
          }
        }
      }
    },
    Card: {
      baseStyle: {
        container: {
          bg: 'rgba(255,150,50,0.04)',
          borderColor: 'rgba(255,150,50,0.08)',
          backdropFilter: 'blur(12px)',
        }
      }
    },
    Accordion: {
      baseStyle: {
        container: {
          bg: 'rgba(255,150,50,0.04)',
          borderColor: 'rgba(255,150,50,0.08)',
        },
        panel: {
          bg: 'rgba(255,150,50,0.02)',
          color: 'white'
        },
        button: {
          _hover: { bg: 'whiteAlpha.100' },
          _expanded: { bg: 'whiteAlpha.100', color: 'brand.300' }
        }
      }
    }
  }
})

export default theme
